import React from "react";

export default React.createContext({
  active: null,
  isActive: (id) => {
    return this.active === id;
  },
});
